import { createSlice } from '@reduxjs/toolkit';
import { editInquiryInfo, getInquiriesList, getInquiryById } from './inquiriesService';

const initialState = {
    inquiriesList: {
        isInquiriesLoading: null,
        isInquiriesSuccess: null,
        pageCount: 0,
        inquiries: [],
    },
    inquiryDetails: {
        isInquiryLoading: null,
        isInquirySuccess: null,
        inquiry: null,
    },
    updateInquiryDetails: {
        isInquiryUpdateing: null,
        isUpdateSuccess: null,
        inquiryDetails: [],
    },
};

const inquiriesSlice = createSlice({
    name: 'inquiry',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getInquiriesList.pending, (state) => {
            state.inquiriesList = {
                ...initialState.inquiriesList,
                isInquiriesLoading: true,
            };
        });

        builder.addCase(getInquiriesList.rejected, (state) => {
            state.inquiriesList = {
                ...initialState.inquiriesList,
                isInquiriesLoading: false,
                isInquiriesSuccess: false,
            };
        });

        builder.addCase(getInquiriesList.fulfilled, (state, action) => {
            state.inquiriesList = {
                ...initialState.inquiriesList,
                isInquiriesLoading: false,
                isInquiriesSuccess: true,
                pageCount: action.payload.pageCount || 0,
                inquiries: action.payload.data || [],
            };
        });

        //Inquiry update
        builder.addCase(editInquiryInfo.pending, (state) => {
            state.updateInquiryDetails = {
                ...initialState.updateInquiryDetails,
                isInquiryUpdateing: true,
            };
        });

        builder.addCase(editInquiryInfo.rejected, (state) => {
            state.updateInquiryDetails = {
                ...initialState.updateInquiryDetails,
                isInquiryUpdateing: false,
                isUpdateSuccess: false,
            };
        });

        builder.addCase(editInquiryInfo.fulfilled, (state, action) => {
            state.updateInquiryDetails = {
                ...initialState.updateInquiryDetails,
                isInquiryUpdateing: false,
                isUpdateSuccess: true,
                inquiryDetails: action.payload.data || [],
            };
        });

         //Inquiry details
         builder.addCase(getInquiryById.pending, (state) => {
            state.inquiryDetails = {
                ...initialState.inquiryDetails,
                isInquiryLoading: true,
            };
        });

        builder.addCase(getInquiryById.rejected, (state) => {
            state.inquiryDetails = {
                ...initialState.inquiryDetails,
                isInquiryLoading: false,
                isInquirySuccess: false,
            };
        });

        builder.addCase(getInquiryById.fulfilled, (state, action) => {
            state.inquiryDetails = {
                ...initialState.inquiryDetails,
                isInquiryLoading: false,
                isInquirySuccess: true,
                inquiry: action.payload,
            }; 
        });
    },
});

export default inquiriesSlice.reducer;
